import { render, staticRenderFns } from "./b5.vue?vue&type=template&id=d4c5b638&scoped=true&"
import script from "./b5.vue?vue&type=script&lang=js&"
export * from "./b5.vue?vue&type=script&lang=js&"
import style0 from "./b5.vue?vue&type=style&index=0&id=d4c5b638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c5b638",
  null
  
)

export default component.exports